// "모드 변경" 진입점 (A5 / A5-R → Jin 2026-11-04 긴급) — 차량관리 셸 앱바·모바일 헤더·설정 행 세 자리에서 쓴다.
// 버튼을 누르면 화면 고르기 시트(전체·검차·말소) → 고른 화면의 기존 확인 시트 → 전환. 앱 더보기 '모드 변경'과 같은 흐름
// (앱 mode_change_sheet.dart). 말소 칸은 canOfferMalso(대표만, 관리자 제외) 일 때만.
// 조건은 canOfferSimple(user)(허용 role — 업체 플래그 무관) + 검차 셸이 아닐 때(크롬 변형의 차량관리 화면에선 숨김).
// 검차: setChoice('simple') → 셸이 /main/s/home 으로 되돌린다. 말소: 서버 PUT(malso/moreActions.switchToMalso).
// props: { user, variant: 'bar' | 'header' | 'row', showToast }
import React, { useState } from 'react';
import { T, R } from '../theme';
import { useT } from '../../i18n/I18nProvider';
import { canOfferSimple, canOfferMalso, useScreenMode } from './screenMode';
import { SIMPLE_HOME, isManagePath } from './routes';
import ConfirmSheet, { SheetFrame } from './parts/ConfirmSheet';
import { switchToMalso } from '../malso/moreActions';

var btn = { display: 'inline-flex', alignItems: 'center', gap: 6, height: 28, padding: '0 10px',
  borderRadius: R.md, fontSize: 11.5, fontWeight: 700, whiteSpace: 'nowrap', cursor: 'pointer',
  fontFamily: 'inherit', boxSizing: 'border-box', maxWidth: 220, overflow: 'hidden' };
var accent = { border: '1px solid ' + T.accentBd, background: T.accentTint, color: T.accentPress };
var card = { display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginTop: 4, padding: '12px 14px',
  background: T.head, border: '1px solid ' + T.bd, borderRadius: R.card };
var cardText = { fontSize: 12.5, color: T.muted, flex: 1, minWidth: 200 };
var opt = { display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '12px 14px', borderRadius: R.md,
  border: '1px solid ' + T.bd, background: T.card, textAlign: 'start', cursor: 'pointer', fontFamily: 'inherit' };
var optOn = { border: '1px solid ' + T.accentBd, background: T.accentTint, cursor: 'default' };
var optName = { fontSize: 13.5, fontWeight: 700, color: T.ink };
var optSub = { fontSize: 11.5, color: T.muted, marginTop: 2 };
var optBadge = { marginInlineStart: 'auto', fontSize: 11, fontWeight: 700, color: T.accentPress, whiteSpace: 'nowrap' };

function Glyph() {
  return (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" aria-hidden="true" focusable="false"><path d="M4 6h16M7 12h10M10 18h4" /></svg>);
}

function BackToSimple(props) {
  var t = useT();
  var sm = useScreenMode(props.user);
  var st = useState(null); // null | 'pick' | 'simple' | 'malso'
  var open = st[0], setOpen = st[1];

  // 말소 업체 둘러보기 중엔 숨긴다 — 위 띠(돌아가기·계속 쓰기)가 전환을 맡는다(simplify §7).
  if (!canOfferSimple(props.user) || sm.simpleActive || sm.malsoPreview) return null;
  var malsoOk = canOfferMalso(props.user);

  // navigate 를 쓰지 않는다 — 선택이 바뀌면 Dashboard 래퍼가 SimpleShell 로 갈아끼우고,
  // 셸의 catch-all 라우트가 /main/s/home 으로 되돌린다(설정 화면처럼 Router 밖에서 렌더될 수도 있다).
  // 단 차량관리 허용 경로(routes.isManagePath)는 크롬 변형으로 남으므로 검차 홈으로 직접 보낸다 — 전체 리로드(어차피 셸 교체).
  var goSimple = function () {
    setOpen(null);
    sm.setChoice('simple');
    if (isManagePath(window.location.pathname)) window.location.assign(SIMPLE_HOME);
  };
  // 말소 셸 catch-all 이 현재 경로를 말소 홈으로 보낸다(MalsoSwitchRow 와 같은 호출).
  var goMalso = function () {
    setOpen(null);
    switchToMalso(null, props.showToast, t);
  };
  var close = function () { setOpen(null); };
  var option = function (key, name, sub, current) {
    return (<button type="button" key={key} data-testid={'mode-pick-' + key} disabled={current}
      style={Object.assign({}, opt, current ? optOn : null)} onClick={function () { setOpen(key); }}>
      <span style={{ minWidth: 0 }}><div style={optName}>{name}</div><div style={optSub}>{sub}</div></span>
      {current ? <span style={optBadge}>{t('modeChangeCurrentBadge')}</span> : null}
    </button>);
  };
  var sheets = (<React.Fragment>
    <SheetFrame open={open === 'pick'} title={t('modeChangeTitle')} onClose={close} closeLabel={t('actionClose')}>
      {option('full', t('modeChangeFull'), t('simpleShowAllSub'), true)}
      {option('simple', t('modeChangeSimple'), t('simpleBackToSimpleSub'), false)}
      {malsoOk ? option('malso', t('modeChangeMalso'), t('malsoModeSwitchToMalsoSub'), false) : null}
    </SheetFrame>
    <ConfirmSheet open={open === 'simple'} title={t('simpleB1ShowSimpleSheetTitle')}
      headline={t('simpleB1SheetSimpleHeadline')} sub={t('simpleB1SheetSimpleSub')} hint={t('simpleB1ShowSimpleHint')}
      confirmLabel={t('simpleBackToSimple')} onConfirm={goSimple} onClose={close} />
    {malsoOk ? (<ConfirmSheet open={open === 'malso'} title={t('malsoModeSheetToMalsoTitle')} sub={t('malsoModeSheetToMalsoBody')}
      confirmLabel={t('malsoModeSwitchToMalso')} onConfirm={goMalso} onClose={close} />) : null}
  </React.Fragment>);
  var openPick = function () { setOpen('pick'); };

  if (props.variant === 'row') {
    return (<div className="ss-back-row" style={card}>
      <span style={cardText}>{t('modeChangeRowSub', { mode: t('modeChangeFull') })}</span>
      <button type="button" data-testid="back-to-simple" style={Object.assign({}, btn, accent, { height: 32 })}
        onClick={openPick}><Glyph />{t('modeChangeRow')}</button>
      {sheets}
    </div>);
  }

  return (<React.Fragment>
    <button type="button" data-testid="back-to-simple" className={'ss-back-' + (props.variant || 'bar')}
      style={Object.assign({}, btn, accent)} onClick={openPick}>
      <Glyph />{t('modeChangeRow')}
    </button>
    {sheets}
  </React.Fragment>);
}

export default BackToSimple;
